import * as React from 'react';
import styled from '@emotion/styled';
import classnames from 'classnames';
const TabsContainer = styled.div `
  display: flex;
  flex-flow: row wrap;
  align-items: stretch;
  justify-content: flex-start;

  button {
    background: none;
    border: 0;
    cursor: pointer;

    margin: 3px;
    padding: 10px 20px;
    font-weight: 500;
    text-transform: uppercase;
    letter-spacing: 1px;
    color: ${(props) => props.theme.activeColour};

    &.selected,
    &:hover {
      background: ${(props) => props.theme.activeColour};
      color: white;
    }

    &:focus {
      outline: none;
      box-shadow: none;
    }
  }
`;
export const Tabs = ({ tabs, initial, renderers }) => {
    const [selectedTab, setTab] = React.useState(initial);
    const Renderer = selectedTab && renderers[selectedTab];
    return (React.createElement(React.Fragment, null,
        React.createElement(TabsContainer, null, tabs.map((label) => (React.createElement("button", { key: label, className: classnames({ selected: selectedTab === label }), onClick: () => setTab(label) }, label)))),
        Renderer && React.createElement(Renderer, null)));
};
//# sourceMappingURL=tabs.js.map